import { msg } from 'gt-react';
import { ArrowsLeftRightIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
  requirePermission,
} from '../../route';
import { searchRexelFilesSearchSchema } from '../search-844/rexel/searchRexelFilesSearch';

const Search844Page = lazyRouteComponent(
  () => import('../search-844/Search844Page'),
  'Search844Page',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ship-and-debit/search-rexel-files',
  staticData: {
    app: {
      nav: {
        label: msg('Search Rexel Files', {
          context: 'sidebar nav label, Ship and Debit Admin section',
        }),
        icon: <ArrowsLeftRightIcon className="h-4 w-4" weight="fill" />,
        group: 'Ship and Debit Admin',
        order: 30,
      },
      access: {
        modulesAnyOf: [ProductModule.SHIP_AND_DEBIT],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.SDAdmin }],
      },
    },
  },
  component: Search844Page,
  validateSearch: searchRexelFilesSearchSchema,
  loader: () => ({
    crumb: msg('Search Rexel Files', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.SHIP_AND_DEBIT],
    });
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.SDAdmin,
    });
  },
});
